import React from 'react'
import { Avatar as AvatarUI } from '@duik/it'
import styled from '@emotion/styled'

const StyledAvatar = styled(AvatarUI)`
  margin-right: 20px;
`

const Avatar = ({ content, color }) => <StyledAvatar avatarPlaceholder={{ content, color }} />

export default Avatar
